/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as ResetPasswordRouteImport } from './routes/reset-password'
import { Route as LoginRouteImport } from './routes/login'
import { Route as ForgotPasswordRouteImport } from './routes/forgot-password'
import { Route as AuthenticatedRouteImport } from './routes/_authenticated'
import { Route as AuthenticatedIndexRouteImport } from './routes/_authenticated/index'
import { Route as AuthenticatedUsersRouteImport } from './routes/_authenticated/users'
import { Route as AuthenticatedNodeComponentTypesRouteImport } from './routes/_authenticated/node-component-types'
import { Route as AuthenticatedInstrumentsRouteImport } from './routes/_authenticated/instruments'
import { Route as AuthenticatedAuditLogsRouteImport } from './routes/_authenticated/audit-logs'
import { Route as AuthenticatedSuppliersIndexRouteImport } from './routes/_authenticated/suppliers/index'
import { Route as AuthenticatedProjectsIndexRouteImport } from './routes/_authenticated/projects/index'
import { Route as AuthenticatedSuppliersSupplierIdRouteImport } from './routes/_authenticated/suppliers/$supplierId'
import { Route as AuthenticatedProjectsDefinitionRouteImport } from './routes/_authenticated/projects/definition'
import { Route as AuthenticatedProjectsProjectIdRouteImport } from './routes/_authenticated/projects/$projectId'
import { Route as AuthenticatedProjectsProjectIdIndexRouteImport } from './routes/_authenticated/projects/$projectId/index'
import { Route as AuthenticatedProjectsProjectIdSettingsRouteImport } from './routes/_authenticated/projects/$projectId_.settings'
import { Route as AuthenticatedProjectsProjectIdPlanningWorkspaceRouteImport } from './routes/_authenticated/projects/$projectId_.planning-workspace'
import { Route as AuthenticatedProjectsProjectIdDefinitionRouteImport } from './routes/_authenticated/projects/$projectId_.definition'
import { Route as AuthenticatedProjectsProjectIdSuppliesRouteImport } from './routes/_authenticated/projects/$projectId/supplies'
import { Route as AuthenticatedProjectsProjectIdReportsRouteImport } from './routes/_authenticated/projects/$projectId/reports'
import { Route as AuthenticatedProjectsProjectIdPersonsRouteImport } from './routes/_authenticated/projects/$projectId/persons'
import { Route as AuthenticatedProjectsProjectIdNetworksRouteImport } from './routes/_authenticated/projects/$projectId/networks'
import { Route as AuthenticatedProjectsProjectIdMaterialsRouteImport } from './routes/_authenticated/projects/$projectId/materials'
import { Route as AuthenticatedProjectsProjectIdDocumentsRouteImport } from './routes/_authenticated/projects/$projectId/documents'
import { Route as AuthenticatedProjectsProjectIdBenchmarksRouteImport } from './routes/_authenticated/projects/$projectId/benchmarks'

const ResetPasswordRoute = ResetPasswordRouteImport.update({
  id: '/reset-password',
  path: '/reset-password',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const ForgotPasswordRoute = ForgotPasswordRouteImport.update({
  id: '/forgot-password',
  path: '/forgot-password',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedRoute = AuthenticatedRouteImport.update({
  id: '/_authenticated',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedIndexRoute = AuthenticatedIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedUsersRoute = AuthenticatedUsersRouteImport.update({
  id: '/users',
  path: '/users',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedNodeComponentTypesRoute =
  AuthenticatedNodeComponentTypesRouteImport.update({
    id: '/node-component-types',
    path: '/node-component-types',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedInstrumentsRoute =
  AuthenticatedInstrumentsRouteImport.update({
    id: '/instruments',
    path: '/instruments',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedAuditLogsRoute = AuthenticatedAuditLogsRouteImport.update({
  id: '/audit-logs',
  path: '/audit-logs',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedSuppliersIndexRoute =
  AuthenticatedSuppliersIndexRouteImport.update({
    id: '/suppliers/',
    path: '/suppliers/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedProjectsIndexRoute =
  AuthenticatedProjectsIndexRouteImport.update({
    id: '/projects/',
    path: '/projects/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedSuppliersSupplierIdRoute =
  AuthenticatedSuppliersSupplierIdRouteImport.update({
    id: '/suppliers/$supplierId',
    path: '/suppliers/$supplierId',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedProjectsDefinitionRoute =
  AuthenticatedProjectsDefinitionRouteImport.update({
    id: '/projects/definition',
    path: '/projects/definition',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedProjectsProjectIdRoute =
  AuthenticatedProjectsProjectIdRouteImport.update({
    id: '/projects/$projectId',
    path: '/projects/$projectId',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedProjectsProjectIdIndexRoute =
  AuthenticatedProjectsProjectIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedProjectsProjectIdRoute,
  } as any)
const AuthenticatedProjectsProjectIdSettingsRoute =
  AuthenticatedProjectsProjectIdSettingsRouteImport.update({
    id: '/projects/$projectId_/settings',
    path: '/projects/$projectId/settings',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedProjectsProjectIdPlanningWorkspaceRoute =
  AuthenticatedProjectsProjectIdPlanningWorkspaceRouteImport.update({
    id: '/projects/$projectId_/planning-workspace',
    path: '/projects/$projectId/planning-workspace',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedProjectsProjectIdDefinitionRoute =
  AuthenticatedProjectsProjectIdDefinitionRouteImport.update({
    id: '/projects/$projectId_/definition',
    path: '/projects/$projectId/definition',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedProjectsProjectIdSuppliesRoute =
  AuthenticatedProjectsProjectIdSuppliesRouteImport.update({
    id: '/supplies',
    path: '/supplies',
    getParentRoute: () => AuthenticatedProjectsProjectIdRoute,
  } as any)
const AuthenticatedProjectsProjectIdReportsRoute =
  AuthenticatedProjectsProjectIdReportsRouteImport.update({
    id: '/reports',
    path: '/reports',
    getParentRoute: () => AuthenticatedProjectsProjectIdRoute,
  } as any)
const AuthenticatedProjectsProjectIdPersonsRoute =
  AuthenticatedProjectsProjectIdPersonsRouteImport.update({
    id: '/persons',
    path: '/persons',
    getParentRoute: () => AuthenticatedProjectsProjectIdRoute,
  } as any)
const AuthenticatedProjectsProjectIdNetworksRoute =
  AuthenticatedProjectsProjectIdNetworksRouteImport.update({
    id: '/networks',
    path: '/networks',
    getParentRoute: () => AuthenticatedProjectsProjectIdRoute,
  } as any)
const AuthenticatedProjectsProjectIdMaterialsRoute =
  AuthenticatedProjectsProjectIdMaterialsRouteImport.update({
    id: '/materials',
    path: '/materials',
    getParentRoute: () => AuthenticatedProjectsProjectIdRoute,
  } as any)
const AuthenticatedProjectsProjectIdDocumentsRoute =
  AuthenticatedProjectsProjectIdDocumentsRouteImport.update({
    id: '/documents',
    path: '/documents',
    getParentRoute: () => AuthenticatedProjectsProjectIdRoute,
  } as any)
const AuthenticatedProjectsProjectIdBenchmarksRoute =
  AuthenticatedProjectsProjectIdBenchmarksRouteImport.update({
    id: '/benchmarks',
    path: '/benchmarks',
    getParentRoute: () => AuthenticatedProjectsProjectIdRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof AuthenticatedIndexRoute
  '/forgot-password': typeof ForgotPasswordRoute
  '/login': typeof LoginRoute
  '/reset-password': typeof ResetPasswordRoute
  '/audit-logs': typeof AuthenticatedAuditLogsRoute
  '/instruments': typeof AuthenticatedInstrumentsRoute
  '/node-component-types': typeof AuthenticatedNodeComponentTypesRoute
  '/users': typeof AuthenticatedUsersRoute
  '/projects/$projectId': typeof AuthenticatedProjectsProjectIdRouteWithChildren
  '/projects/definition': typeof AuthenticatedProjectsDefinitionRoute
  '/suppliers/$supplierId': typeof AuthenticatedSuppliersSupplierIdRoute
  '/projects/': typeof AuthenticatedProjectsIndexRoute
  '/suppliers/': typeof AuthenticatedSuppliersIndexRoute
  '/projects/$projectId/benchmarks': typeof AuthenticatedProjectsProjectIdBenchmarksRoute
  '/projects/$projectId/documents': typeof AuthenticatedProjectsProjectIdDocumentsRoute
  '/projects/$projectId/materials': typeof AuthenticatedProjectsProjectIdMaterialsRoute
  '/projects/$projectId/networks': typeof AuthenticatedProjectsProjectIdNetworksRoute
  '/projects/$projectId/persons': typeof AuthenticatedProjectsProjectIdPersonsRoute
  '/projects/$projectId/reports': typeof AuthenticatedProjectsProjectIdReportsRoute
  '/projects/$projectId/supplies': typeof AuthenticatedProjectsProjectIdSuppliesRoute
  '/projects/$projectId/definition': typeof AuthenticatedProjectsProjectIdDefinitionRoute
  '/projects/$projectId/planning-workspace': typeof AuthenticatedProjectsProjectIdPlanningWorkspaceRoute
  '/projects/$projectId/settings': typeof AuthenticatedProjectsProjectIdSettingsRoute
  '/projects/$projectId/': typeof AuthenticatedProjectsProjectIdIndexRoute
}
export interface FileRoutesByTo {
  '/forgot-password': typeof ForgotPasswordRoute
  '/login': typeof LoginRoute
  '/reset-password': typeof ResetPasswordRoute
  '/audit-logs': typeof AuthenticatedAuditLogsRoute
  '/instruments': typeof AuthenticatedInstrumentsRoute
  '/node-component-types': typeof AuthenticatedNodeComponentTypesRoute
  '/users': typeof AuthenticatedUsersRoute
  '/': typeof AuthenticatedIndexRoute
  '/projects/definition': typeof AuthenticatedProjectsDefinitionRoute
  '/suppliers/$supplierId': typeof AuthenticatedSuppliersSupplierIdRoute
  '/projects': typeof AuthenticatedProjectsIndexRoute
  '/suppliers': typeof AuthenticatedSuppliersIndexRoute
  '/projects/$projectId/benchmarks': typeof AuthenticatedProjectsProjectIdBenchmarksRoute
  '/projects/$projectId/documents': typeof AuthenticatedProjectsProjectIdDocumentsRoute
  '/projects/$projectId/materials': typeof AuthenticatedProjectsProjectIdMaterialsRoute
  '/projects/$projectId/networks': typeof AuthenticatedProjectsProjectIdNetworksRoute
  '/projects/$projectId/persons': typeof AuthenticatedProjectsProjectIdPersonsRoute
  '/projects/$projectId/reports': typeof AuthenticatedProjectsProjectIdReportsRoute
  '/projects/$projectId/supplies': typeof AuthenticatedProjectsProjectIdSuppliesRoute
  '/projects/$projectId/definition': typeof AuthenticatedProjectsProjectIdDefinitionRoute
  '/projects/$projectId/planning-workspace': typeof AuthenticatedProjectsProjectIdPlanningWorkspaceRoute
  '/projects/$projectId/settings': typeof AuthenticatedProjectsProjectIdSettingsRoute
  '/projects/$projectId': typeof AuthenticatedProjectsProjectIdIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_authenticated': typeof AuthenticatedRouteWithChildren
  '/forgot-password': typeof ForgotPasswordRoute
  '/login': typeof LoginRoute
  '/reset-password': typeof ResetPasswordRoute
  '/_authenticated/audit-logs': typeof AuthenticatedAuditLogsRoute
  '/_authenticated/instruments': typeof AuthenticatedInstrumentsRoute
  '/_authenticated/node-component-types': typeof AuthenticatedNodeComponentTypesRoute
  '/_authenticated/users': typeof AuthenticatedUsersRoute
  '/_authenticated/': typeof AuthenticatedIndexRoute
  '/_authenticated/projects/$projectId': typeof AuthenticatedProjectsProjectIdRouteWithChildren
  '/_authenticated/projects/definition': typeof AuthenticatedProjectsDefinitionRoute
  '/_authenticated/suppliers/$supplierId': typeof AuthenticatedSuppliersSupplierIdRoute
  '/_authenticated/projects/': typeof AuthenticatedProjectsIndexRoute
  '/_authenticated/suppliers/': typeof AuthenticatedSuppliersIndexRoute
  '/_authenticated/projects/$projectId/benchmarks': typeof AuthenticatedProjectsProjectIdBenchmarksRoute
  '/_authenticated/projects/$projectId/documents': typeof AuthenticatedProjectsProjectIdDocumentsRoute
  '/_authenticated/projects/$projectId/materials': typeof AuthenticatedProjectsProjectIdMaterialsRoute
  '/_authenticated/projects/$projectId/networks': typeof AuthenticatedProjectsProjectIdNetworksRoute
  '/_authenticated/projects/$projectId/persons': typeof AuthenticatedProjectsProjectIdPersonsRoute
  '/_authenticated/projects/$projectId/reports': typeof AuthenticatedProjectsProjectIdReportsRoute
  '/_authenticated/projects/$projectId/supplies': typeof AuthenticatedProjectsProjectIdSuppliesRoute
  '/_authenticated/projects/$projectId_/definition': typeof AuthenticatedProjectsProjectIdDefinitionRoute
  '/_authenticated/projects/$projectId_/planning-workspace': typeof AuthenticatedProjectsProjectIdPlanningWorkspaceRoute
  '/_authenticated/projects/$projectId_/settings': typeof AuthenticatedProjectsProjectIdSettingsRoute
  '/_authenticated/projects/$projectId/': typeof AuthenticatedProjectsProjectIdIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/forgot-password'
    | '/login'
    | '/reset-password'
    | '/audit-logs'
    | '/instruments'
    | '/node-component-types'
    | '/users'
    | '/projects/$projectId'
    | '/projects/definition'
    | '/suppliers/$supplierId'
    | '/projects/'
    | '/suppliers/'
    | '/projects/$projectId/benchmarks'
    | '/projects/$projectId/documents'
    | '/projects/$projectId/materials'
    | '/projects/$projectId/networks'
    | '/projects/$projectId/persons'
    | '/projects/$projectId/reports'
    | '/projects/$projectId/supplies'
    | '/projects/$projectId/definition'
    | '/projects/$projectId/planning-workspace'
    | '/projects/$projectId/settings'
    | '/projects/$projectId/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/forgot-password'
    | '/login'
    | '/reset-password'
    | '/audit-logs'
    | '/instruments'
    | '/node-component-types'
    | '/users'
    | '/'
    | '/projects/definition'
    | '/suppliers/$supplierId'
    | '/projects'
    | '/suppliers'
    | '/projects/$projectId/benchmarks'
    | '/projects/$projectId/documents'
    | '/projects/$projectId/materials'
    | '/projects/$projectId/networks'
    | '/projects/$projectId/persons'
    | '/projects/$projectId/reports'
    | '/projects/$projectId/supplies'
    | '/projects/$projectId/definition'
    | '/projects/$projectId/planning-workspace'
    | '/projects/$projectId/settings'
    | '/projects/$projectId'
  id:
    | '__root__'
    | '/_authenticated'
    | '/forgot-password'
    | '/login'
    | '/reset-password'
    | '/_authenticated/audit-logs'
    | '/_authenticated/instruments'
    | '/_authenticated/node-component-types'
    | '/_authenticated/users'
    | '/_authenticated/'
    | '/_authenticated/projects/$projectId'
    | '/_authenticated/projects/definition'
    | '/_authenticated/suppliers/$supplierId'
    | '/_authenticated/projects/'
    | '/_authenticated/suppliers/'
    | '/_authenticated/projects/$projectId/benchmarks'
    | '/_authenticated/projects/$projectId/documents'
    | '/_authenticated/projects/$projectId/materials'
    | '/_authenticated/projects/$projectId/networks'
    | '/_authenticated/projects/$projectId/persons'
    | '/_authenticated/projects/$projectId/reports'
    | '/_authenticated/projects/$projectId/supplies'
    | '/_authenticated/projects/$projectId_/definition'
    | '/_authenticated/projects/$projectId_/planning-workspace'
    | '/_authenticated/projects/$projectId_/settings'
    | '/_authenticated/projects/$projectId/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AuthenticatedRoute: typeof AuthenticatedRouteWithChildren
  ForgotPasswordRoute: typeof ForgotPasswordRoute
  LoginRoute: typeof LoginRoute
  ResetPasswordRoute: typeof ResetPasswordRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/reset-password': {
      id: '/reset-password'
      path: '/reset-password'
      fullPath: '/reset-password'
      preLoaderRoute: typeof ResetPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/forgot-password': {
      id: '/forgot-password'
      path: '/forgot-password'
      fullPath: '/forgot-password'
      preLoaderRoute: typeof ForgotPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated': {
      id: '/_authenticated'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated/': {
      id: '/_authenticated/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/users': {
      id: '/_authenticated/users'
      path: '/users'
      fullPath: '/users'
      preLoaderRoute: typeof AuthenticatedUsersRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/node-component-types': {
      id: '/_authenticated/node-component-types'
      path: '/node-component-types'
      fullPath: '/node-component-types'
      preLoaderRoute: typeof AuthenticatedNodeComponentTypesRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/instruments': {
      id: '/_authenticated/instruments'
      path: '/instruments'
      fullPath: '/instruments'
      preLoaderRoute: typeof AuthenticatedInstrumentsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/audit-logs': {
      id: '/_authenticated/audit-logs'
      path: '/audit-logs'
      fullPath: '/audit-logs'
      preLoaderRoute: typeof AuthenticatedAuditLogsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/suppliers/': {
      id: '/_authenticated/suppliers/'
      path: '/suppliers'
      fullPath: '/suppliers/'
      preLoaderRoute: typeof AuthenticatedSuppliersIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/projects/': {
      id: '/_authenticated/projects/'
      path: '/projects'
      fullPath: '/projects/'
      preLoaderRoute: typeof AuthenticatedProjectsIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/suppliers/$supplierId': {
      id: '/_authenticated/suppliers/$supplierId'
      path: '/suppliers/$supplierId'
      fullPath: '/suppliers/$supplierId'
      preLoaderRoute: typeof AuthenticatedSuppliersSupplierIdRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/projects/definition': {
      id: '/_authenticated/projects/definition'
      path: '/projects/definition'
      fullPath: '/projects/definition'
      preLoaderRoute: typeof AuthenticatedProjectsDefinitionRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/projects/$projectId': {
      id: '/_authenticated/projects/$projectId'
      path: '/projects/$projectId'
      fullPath: '/projects/$projectId'
      preLoaderRoute: typeof AuthenticatedProjectsProjectIdRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/projects/$projectId/': {
      id: '/_authenticated/projects/$projectId/'
      path: '/'
      fullPath: '/projects/$projectId/'
      preLoaderRoute: typeof AuthenticatedProjectsProjectIdIndexRouteImport
      parentRoute: typeof AuthenticatedProjectsProjectIdRoute
    }
    '/_authenticated/projects/$projectId_/settings': {
      id: '/_authenticated/projects/$projectId_/settings'
      path: '/projects/$projectId/settings'
      fullPath: '/projects/$projectId/settings'
      preLoaderRoute: typeof AuthenticatedProjectsProjectIdSettingsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/projects/$projectId_/planning-workspace': {
      id: '/_authenticated/projects/$projectId_/planning-workspace'
      path: '/projects/$projectId/planning-workspace'
      fullPath: '/projects/$projectId/planning-workspace'
      preLoaderRoute: typeof AuthenticatedProjectsProjectIdPlanningWorkspaceRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/projects/$projectId_/definition': {
      id: '/_authenticated/projects/$projectId_/definition'
      path: '/projects/$projectId/definition'
      fullPath: '/projects/$projectId/definition'
      preLoaderRoute: typeof AuthenticatedProjectsProjectIdDefinitionRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/projects/$projectId/supplies': {
      id: '/_authenticated/projects/$projectId/supplies'
      path: '/supplies'
      fullPath: '/projects/$projectId/supplies'
      preLoaderRoute: typeof AuthenticatedProjectsProjectIdSuppliesRouteImport
      parentRoute: typeof AuthenticatedProjectsProjectIdRoute
    }
    '/_authenticated/projects/$projectId/reports': {
      id: '/_authenticated/projects/$projectId/reports'
      path: '/reports'
      fullPath: '/projects/$projectId/reports'
      preLoaderRoute: typeof AuthenticatedProjectsProjectIdReportsRouteImport
      parentRoute: typeof AuthenticatedProjectsProjectIdRoute
    }
    '/_authenticated/projects/$projectId/persons': {
      id: '/_authenticated/projects/$projectId/persons'
      path: '/persons'
      fullPath: '/projects/$projectId/persons'
      preLoaderRoute: typeof AuthenticatedProjectsProjectIdPersonsRouteImport
      parentRoute: typeof AuthenticatedProjectsProjectIdRoute
    }
    '/_authenticated/projects/$projectId/networks': {
      id: '/_authenticated/projects/$projectId/networks'
      path: '/networks'
      fullPath: '/projects/$projectId/networks'
      preLoaderRoute: typeof AuthenticatedProjectsProjectIdNetworksRouteImport
      parentRoute: typeof AuthenticatedProjectsProjectIdRoute
    }
    '/_authenticated/projects/$projectId/materials': {
      id: '/_authenticated/projects/$projectId/materials'
      path: '/materials'
      fullPath: '/projects/$projectId/materials'
      preLoaderRoute: typeof AuthenticatedProjectsProjectIdMaterialsRouteImport
      parentRoute: typeof AuthenticatedProjectsProjectIdRoute
    }
    '/_authenticated/projects/$projectId/documents': {
      id: '/_authenticated/projects/$projectId/documents'
      path: '/documents'
      fullPath: '/projects/$projectId/documents'
      preLoaderRoute: typeof AuthenticatedProjectsProjectIdDocumentsRouteImport
      parentRoute: typeof AuthenticatedProjectsProjectIdRoute
    }
    '/_authenticated/projects/$projectId/benchmarks': {
      id: '/_authenticated/projects/$projectId/benchmarks'
      path: '/benchmarks'
      fullPath: '/projects/$projectId/benchmarks'
      preLoaderRoute: typeof AuthenticatedProjectsProjectIdBenchmarksRouteImport
      parentRoute: typeof AuthenticatedProjectsProjectIdRoute
    }
  }
}

interface AuthenticatedProjectsProjectIdRouteChildren {
  AuthenticatedProjectsProjectIdBenchmarksRoute: typeof AuthenticatedProjectsProjectIdBenchmarksRoute
  AuthenticatedProjectsProjectIdDocumentsRoute: typeof AuthenticatedProjectsProjectIdDocumentsRoute
  AuthenticatedProjectsProjectIdMaterialsRoute: typeof AuthenticatedProjectsProjectIdMaterialsRoute
  AuthenticatedProjectsProjectIdNetworksRoute: typeof AuthenticatedProjectsProjectIdNetworksRoute
  AuthenticatedProjectsProjectIdPersonsRoute: typeof AuthenticatedProjectsProjectIdPersonsRoute
  AuthenticatedProjectsProjectIdReportsRoute: typeof AuthenticatedProjectsProjectIdReportsRoute
  AuthenticatedProjectsProjectIdSuppliesRoute: typeof AuthenticatedProjectsProjectIdSuppliesRoute
  AuthenticatedProjectsProjectIdIndexRoute: typeof AuthenticatedProjectsProjectIdIndexRoute
}

const AuthenticatedProjectsProjectIdRouteChildren: AuthenticatedProjectsProjectIdRouteChildren =
  {
    AuthenticatedProjectsProjectIdBenchmarksRoute:
      AuthenticatedProjectsProjectIdBenchmarksRoute,
    AuthenticatedProjectsProjectIdDocumentsRoute:
      AuthenticatedProjectsProjectIdDocumentsRoute,
    AuthenticatedProjectsProjectIdMaterialsRoute:
      AuthenticatedProjectsProjectIdMaterialsRoute,
    AuthenticatedProjectsProjectIdNetworksRoute:
      AuthenticatedProjectsProjectIdNetworksRoute,
    AuthenticatedProjectsProjectIdPersonsRoute:
      AuthenticatedProjectsProjectIdPersonsRoute,
    AuthenticatedProjectsProjectIdReportsRoute:
      AuthenticatedProjectsProjectIdReportsRoute,
    AuthenticatedProjectsProjectIdSuppliesRoute:
      AuthenticatedProjectsProjectIdSuppliesRoute,
    AuthenticatedProjectsProjectIdIndexRoute:
      AuthenticatedProjectsProjectIdIndexRoute,
  }

const AuthenticatedProjectsProjectIdRouteWithChildren =
  AuthenticatedProjectsProjectIdRoute._addFileChildren(
    AuthenticatedProjectsProjectIdRouteChildren,
  )

interface AuthenticatedRouteChildren {
  AuthenticatedAuditLogsRoute: typeof AuthenticatedAuditLogsRoute
  AuthenticatedInstrumentsRoute: typeof AuthenticatedInstrumentsRoute
  AuthenticatedNodeComponentTypesRoute: typeof AuthenticatedNodeComponentTypesRoute
  AuthenticatedUsersRoute: typeof AuthenticatedUsersRoute
  AuthenticatedIndexRoute: typeof AuthenticatedIndexRoute
  AuthenticatedProjectsProjectIdRoute: typeof AuthenticatedProjectsProjectIdRouteWithChildren
  AuthenticatedProjectsDefinitionRoute: typeof AuthenticatedProjectsDefinitionRoute
  AuthenticatedSuppliersSupplierIdRoute: typeof AuthenticatedSuppliersSupplierIdRoute
  AuthenticatedProjectsIndexRoute: typeof AuthenticatedProjectsIndexRoute
  AuthenticatedSuppliersIndexRoute: typeof AuthenticatedSuppliersIndexRoute
  AuthenticatedProjectsProjectIdDefinitionRoute: typeof AuthenticatedProjectsProjectIdDefinitionRoute
  AuthenticatedProjectsProjectIdPlanningWorkspaceRoute: typeof AuthenticatedProjectsProjectIdPlanningWorkspaceRoute
  AuthenticatedProjectsProjectIdSettingsRoute: typeof AuthenticatedProjectsProjectIdSettingsRoute
}

const AuthenticatedRouteChildren: AuthenticatedRouteChildren = {
  AuthenticatedAuditLogsRoute: AuthenticatedAuditLogsRoute,
  AuthenticatedInstrumentsRoute: AuthenticatedInstrumentsRoute,
  AuthenticatedNodeComponentTypesRoute: AuthenticatedNodeComponentTypesRoute,
  AuthenticatedUsersRoute: AuthenticatedUsersRoute,
  AuthenticatedIndexRoute: AuthenticatedIndexRoute,
  AuthenticatedProjectsProjectIdRoute:
    AuthenticatedProjectsProjectIdRouteWithChildren,
  AuthenticatedProjectsDefinitionRoute: AuthenticatedProjectsDefinitionRoute,
  AuthenticatedSuppliersSupplierIdRoute: AuthenticatedSuppliersSupplierIdRoute,
  AuthenticatedProjectsIndexRoute: AuthenticatedProjectsIndexRoute,
  AuthenticatedSuppliersIndexRoute: AuthenticatedSuppliersIndexRoute,
  AuthenticatedProjectsProjectIdDefinitionRoute:
    AuthenticatedProjectsProjectIdDefinitionRoute,
  AuthenticatedProjectsProjectIdPlanningWorkspaceRoute:
    AuthenticatedProjectsProjectIdPlanningWorkspaceRoute,
  AuthenticatedProjectsProjectIdSettingsRoute:
    AuthenticatedProjectsProjectIdSettingsRoute,
}

const AuthenticatedRouteWithChildren = AuthenticatedRoute._addFileChildren(
  AuthenticatedRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  AuthenticatedRoute: AuthenticatedRouteWithChildren,
  ForgotPasswordRoute: ForgotPasswordRoute,
  LoginRoute: LoginRoute,
  ResetPasswordRoute: ResetPasswordRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
